module.exports = __webpack_public_path__ + "img/clerk.910415f6.png";